module.exports = __webpack_public_path__ + "static/media/iconGallery.8cc9c93c.svg";